export default __webpack_public_path__ + "static/media/property_991.d8ca5d80.png";